import React, { Component } from "react"
import { Modal } from "antd"
import "./Index.scss"

export default class Index extends Component {

  handleOk() {
    this.props.onOk(this.props.editData)
  }

  render() {
    return (
      <Modal className="no-footer"
        {...this.props}
        title={<div className="cmodal-title">
        <i className="dna-icon" />{this.props.title}<i className="dna-icon" /></div>}
      >
        {this.props.children}
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/CModalNoFooter/index.js